import { render } from "./ProfileSubscriptions.vue?vue&type=template&id=372bfd7a&scoped=true"
import script from "./ProfileSubscriptions.vue?vue&type=script&lang=js"
export * from "./ProfileSubscriptions.vue?vue&type=script&lang=js"

import "./ProfileSubscriptions.vue?vue&type=style&index=0&id=372bfd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372bfd7a"]])

export default __exports__